import { Flex, Text, Card } from '@scale/scaleui-radix';
import type { CalendarDataGeneratorContext } from '@scale/genai-compass-shared/cards/calendar_data_generator';

interface ConfigurationSummaryProps {
  context: CalendarDataGeneratorContext;
}

export default function ConfigurationSummary({ context }: ConfigurationSummaryProps) {
  const totalTasks = (context.rowsToGenerate || 100) * (context.locales?.length || 0);

  return (
    <Card style={{ padding: '16px', backgroundColor: '#f9fafb' }}>
      <Flex direction="column" gap="2">
        <Text size="2" weight="bold">
          Configuration Summary
        </Text>
        <Text size="2">
          <strong>Total Tasks to Generate:</strong> {totalTasks}
        </Text>
        <Text size="2">
          <strong>Tasks per Locale:</strong> {context.rowsToGenerate || 100}
        </Text>
        <Text size="2">
          <strong>Locales Selected:</strong> {context.locales?.length || 0}
        </Text>
        <Text size="2">
          <strong>Calendars Range:</strong> {context.minCalendars || 1} -{' '}
          {context.maxCalendars || 3}
        </Text>
        <Text size="2">
          <strong>Events Range:</strong> {context.minEvents || 1} - {context.maxEvents || 10} per
          calendar
        </Text>
        <Text size="2">
          <strong>Date Range:</strong> {context.earliestDate || '2026-01-12'} to{' '}
          {context.latestDate || '2026-03-12'}
        </Text>
        <Text size="2">
          <strong>Max Users per Event:</strong> {context.maxUsers || 5}
        </Text>
      </Flex>
    </Card>
  );
}
